// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getFeaturedCategories, GetFeaturedCategoriesApiParameter } from "@awc/App/Services/CustomCategoryService";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = GetFeaturedCategoriesApiParameter & HasOnSuccess<ServiceResult<CategoryModel[]>> & HasOnError<string>;

type HandlerType = ApiHandler<Parameter, ServiceResult<CategoryModel[]>>;

export const GetCustomCategories: HandlerType = async props => {
    props.apiResult = await getFeaturedCategories({
        categories: props.parameter.categories,
    });
};

export const DispatchOnErrorLoadCustomCategories: HandlerType = props => {
    if (!props.apiResult.successful && props.parameter.onError) {
        props.parameter.onError(props.apiResult.errorMessage || "An error occurred while loading custom categories.");
    }
};

export const DispatchOnSuccessLoadCustomCategories: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.onSuccess) {
        props.parameter.onSuccess(props.apiResult);
    }
};

export const chain = [
    GetCustomCategories,
    DispatchOnErrorLoadCustomCategories,
    DispatchOnSuccessLoadCustomCategories,
];

const loadFeaturedCategories = createHandlerChainRunner(chain, "LoadFeaturedCategories");

export default loadFeaturedCategories;

